import * as action_types from "./constants";
import { GetUserType } from "./types";

export type myUsersState = {
  companyFormList: { label: string; value: string }[];
  companyFormData: {
    position: { label: string; value: string }[];
    service_line: { label: string; value: string }[];
  };
  userDetailData: {
    loader: boolean;
    data: GetUserType | null;
  };
};

const initialState: myUsersState = {
  companyFormList: [],
  companyFormData: {
    position: [],
    service_line: [],
  },
  userDetailData: {
    loader: true,
    data: null,
  },
};

type MyUsersActionType =
  | {
      type: typeof action_types.COMPANY_FORM_LIST;
      data: { label: string; value: string }[];
    }
  | {
      type: typeof action_types.COMPANY_FORM_DATA;
      data: {
        position: { label: string; value: string }[];
        service_line: { label: string; value: string }[];
      };
    }
  | {
      type: typeof action_types.USER_DETAIL_BY_ID;
      data: { payload: GetUserType; loading: boolean };
    };

const myUsersReducer = (
  state = initialState,
  action: MyUsersActionType
): myUsersState => {
  const { type, data } = action;
  switch (type) {
    case action_types.COMPANY_FORM_LIST:
      return {
        ...state,
        companyFormList: data,
      };

    case action_types.COMPANY_FORM_DATA:
      return {
        ...state,
        companyFormData: data,
      };

    case action_types.USER_DETAIL_BY_ID:
      return {
        ...state,
        userDetailData: { data: data?.payload, loader: data?.loading },
      };

    default:
      return state;
  }
};

export default myUsersReducer;
